import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/core/service/request.service';
import { StorageService } from 'src/app/core/service/storage.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ResourceMasterService {
  constructor(
    private storageService: StorageService,
    private restService: RequestService
  ) {}
  getOverRideRto() {
    return this.restService.request('GET', `/api/v5/sa-application-rtos`);
  }
}
